export enum LoadStatus {
  Pristine = 'Pristine',
  Loading = 'Loading',
  Loaded = 'Loaded',
  Failed = 'Failed'
}
